// views.app.reports.news

export default {
  title: 'News Board',
  description: 'Welcome to your personalized news board!'
};
